// @ts-expect-error TS2882: subpath has no `types` condition; it resolves to a real stylesheet at build/dev time
import '@talbenmoshe/phrasier-react-design-system/styles.css';
import React, { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import { ThemeProvider } from '@talbenmoshe/phrasier-react-design-system';
import { AuthContextProvider } from '@talbenmoshe/phrasier-auth-react-model';
import { AuthApp } from './AuthApp.js';
import { createBrowserAuthFacade } from './bootstrap/createBrowserAuthFacade.js';

const root = document.getElementById('root');

if (root === null) {
  throw new Error('Root element not found');
}

const facade = createBrowserAuthFacade();

ReactDOM.createRoot(root).render(
  <StrictMode>
    <ThemeProvider>
      <AuthContextProvider facade={facade}>
        <AuthApp />
      </AuthContextProvider>
    </ThemeProvider>
  </StrictMode>
);
